module.exports = __webpack_public_path__ + "static/media/OPPTIMISE_logo.411c3331.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/OPPTIMISE_logo.png
// module id = 74
// module chunks = 0